/* eslint-disable react/prop-types */
import classnames from "classnames";
import { ImSpinner2 } from "react-icons/im"; // spinner icon

const FormButton = ({
  text,
  disabled = false,
  onClick,
  isDanger = false,
  htmlType = "submit",
  icon = false,
  fullWidth = false,
  loading = false,
  loadingText = "Processing...",
}) => {
  return (
    <button
      type={htmlType}
      onClick={onClick}
      disabled={disabled || loading}
      className={classnames(
        "flex items-center justify-center gap-2 my-2 text-sm px-4 py-2 rounded-md transition cursor-pointer",
        {
          "w-full": fullWidth,
          "bg-primary text-white hover:bg-primary/90": !isDanger,
          "bg-red-600 text-white hover:bg-red-700": isDanger,
          "opacity-50 cursor-not-allowed": disabled || loading,
        }
      )}
    >
      {loading ? (
        <>
          <ImSpinner2 className="animate-spin" />
          {loadingText}
        </>
      ) : (
        <>
          {icon && icon}
          {text}
        </>
      )}
    </button>
  );
};

export default FormButton;
